import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';

function SingleBaseContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/bases/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page">
          <p>Loading...</p>
        </div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page">
          <p>Could not load this base.</p>
        </div>
      </>
    );
  }

  const meta = [
    { label: 'Location', value: `${data.County || 'Unknown'}, ${data.Country || ''}`.replace(/, $/, '') },
    { label: 'Station ID', value: data.StationId || '—' },
    { label: 'Station No.', value: data.StationNumber || '—' },
  ];
  if (data.Lat && data.Lon) {
    meta.push({ label: 'Coordinates', value: `${data.Lat}, ${data.Lon}` });
  }

  const museums = data.Museums || [];

  return (
    <>
      <DetailPageLayout eyebrow="Base" title={data.Name} meta={meta}>
        {data.Description && (
          <DetailSection title="Overview">
            <p>{data.Description}</p>
          </DetailSection>
        )}
        {(data.Address || data.CurrentState || museums.length > 0) && (
          <DetailSection title="Visiting">
            {data.Address && (
              <p><strong>Address:</strong> {data.Address}</p>
            )}
            {data.CurrentState && (
              <p><strong>Current condition:</strong> {data.CurrentState}</p>
            )}
            {museums.map((m, i) => (
              <div key={i} className="museum-block" style={{ marginTop: '1.25rem' }}>
                <p><strong>{m.Name || 'Museum'}</strong></p>
                {m.Hours && <p>Hours: {m.Hours}</p>}
                {m.Website && (
                  <p>
                    Website:{' '}
                    <a
                    
                      href={m.Website.startsWith('http') ? m.Website : `https://${m.Website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {m.Website}
                    </a>
                  </p>
                )}
                {m.Email && (
                  <p>Email: <a href={`mailto:${m.Email}`}>{m.Email}</a></p>
                )}
                {m.Phone && <p>Phone: {m.Phone}</p>}
                {m.Contact && <p>Contact: {m.Contact}</p>}
              </div>
            ))}
          </DetailSection>
        )}
        {data.SitePlanFname && (
          <DetailSection title="Site Plan">
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}/img/${data.SitePlanFname}`}
              alt={`Site plan for ${data.Name}`}
            />
          </DetailSection>
        )}
        {data.LongDescription && (
          <DetailSection title="History">
            <div dangerouslySetInnerHTML={{ __html: data.LongDescription }} />
          </DetailSection>
        )}
        {data.Link && (
          <DetailSection title="Reference">
            <p>
              <a href={data.Link} target="_blank" rel="noopener noreferrer">{data.Link}</a>
            </p>
          </DetailSection>
        )}
      </DetailPageLayout>
    </>
  );
}

export default SingleBaseContent;
